import { useCallback } from "react";

import type { BasicCustomMailSettingInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { BasicCustomMailSettingUpdate } from "./mutation";

export const useUpdateCustomMailSetting = () => {
	const { mutationFunc } = useCustomMutation(BasicCustomMailSettingUpdate);

	const updateCustomMailSetting = useCallback(
		async (input: BasicCustomMailSettingInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return { updateCustomMailSetting };
};
